export enum Role {
  ADMIN = 'ADMIN',
  QUATTUOR = 'QUATTUOR',
  VENDEDOR = 'VENDEDOR',
}
